import React, { useRef } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import UploadLogo from "../../../assets/redesign/uploadLogo.svg";

import styles from "../../../Components/DashboardCard/table.module.css";
import clsx from "clsx";
import { Delete } from "@mui/icons-material";
import { removeCompanyLogoApi } from "../../../api/profile";
import { useSnackbar } from "../../../context/SnackbarContext";
import { images } from "../../../assets/images";
import { useCreatedJobData } from "../../../context/MasterContextProvider";

interface Props {
  handleUpload: any;
  imgUrl: string;
}

const LogoAction = ({ handleUpload, imgUrl }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickUpload = async () => {
    // setAnchorEl(null);
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input dialog
    }
  };

  const handleChange = (e: any) => {
    handleUpload(e);
    setAnchorEl(null);
  };

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const { setCreatedJob } = useCreatedJobData();

  const { showSnackbar } = useSnackbar();

  const handleClickRemove = async () => {
    const resp = await removeCompanyLogoApi();
    if (resp?.responseInfo.httpCode === 200) {
      showSnackbar("Removed Company Logo.", "success");
      setCreatedJob((prevState) => prevState + 1);
      setAnchorEl(null);
    } else {
      showSnackbar(
        resp?.responseInfo?.description || "Something went wrong.",
        "error"
      );
    }
  };

  return (
    <>
      <button className={styles.uploadIcon} onClick={handleClick}>
        <img
          src={images.logoEditPen}
          alt="Park logo"
          width={30}
          height={30}
        />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorPosition={{
          top: 10,
          left: 0,
        }}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className={styles.action_menu}
      >
        <div className={styles.menu}>
          <MenuItem
            onClick={handleClickUpload}
            className={clsx(styles.menuItem)}
          >
            <img src={UploadLogo} />
            <p className={styles.menuItemText}>Upload Logo</p>
            <input
              type="file"
              accept="image/png, image/jpg, image/jpeg"
              style={{ display: "none" }}
              ref={fileInputRef} // Assign ref to the input
              onChange={handleChange}
            />
          </MenuItem>
          {imgUrl !==
            images.companyLogoUpdate && (
            <MenuItem
              onClick={handleClickRemove}
              className={clsx(styles.menuItem)}
            >
              <Delete style={{ marginLeft: "-2px" }} />
              <p className={styles.menuItemText}>Remove</p>
            </MenuItem>
          )}
        </div>
      </Menu>
    </>
  );
};

export default LogoAction;
